<template>
  <li class="llm_card mb_10 px_12 py_12" @click="onCardClick">
    <div class="" style="text-align: left;">
      <h4 class="font_regular text_16 font_600 word_break">{{ chatbot.name ? chatbot.name.substring(0, 50) :"" }}</h4>
    </div>
    <div class="flex_center pl_12">
      <!-- <p class="font_regular text_14 font_400 text_black_secondary">{{ chatbot.status || $t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.READY_STATUS') }}</p> -->
      <Label
        :title="chatbot.assistant_id ? $t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.READY_STATUS'):$t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.NOT_READY_STATUS')"
        :colorScheme="chatbot.assistant_id ? 'success':'secondary'"
      />
    </div>
    <div class="flex_center pl_12">
      <p class="font_regular text_14 font_400 text_black_secondary">{{ chatbot.llm_model }}</p>
    </div>
    <div class="flex_center pl_12">
      <woot-button
        variant="smooth"
        size="small"
        color-scheme="secondary"
        icon="delete"
        class-names="grey-btn btn-width-auto"
        @click.stop="deleteChatbot"
      >
      </woot-button>
    </div>
  </li>
</template>

<script>
import Label from 'dashboard/components/ui/Label';

export default {
  components:{
    Label
  },
  props: {
    chatbot: {
      type: Object,
      required: true,
    },
  },
  methods: {
    deleteChatbot() {
      this.$emit('onDelete', this.chatbot);
    },
    onCardClick(){
      this.$router.push({name: 'llm_bot_edit', params: {llm_bot_id: this.chatbot.id}});
    },
  },
}
</script>

<style scope lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';
@import '~dashboard/assets/scss/woot';

.llm_card{
    display: grid;
    grid-template-columns: 1fr 100px 50px 50px;
    gap: 10px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 1px 2px #232b392d;
    cursor: pointer;
    text-align: center;
    @include breakpoint(medium up) {
      grid-template-columns: 1fr 200px 150px 110px;
    }

}

.btn-width-auto{
  width: auto !important;
}

</style>